export const Routes = {
  home: "/",
  login: "/resetPassword",
};
